define(function(require, exports, module) {
    'use strict';

    module.exports = {
        additionalEvents: {
            'change .username': 'handleUsernameChange'
        },

        handleUsernameChange: function(e) {
            e.target.value = e.target.value.trim();
        }
    };
});
